<template>
  <main class="horizontal-container">
    <section class="left-container">
      <!-- 매장명 & 대기확정 코드 -->
      <header class="top">
        <text-ellipsis class="title">{{ info ? info.name : '매장 접속중' }}</text-ellipsis>
        <otp :otpNumber="otpNumber" :isCWType="info.isCWType" :useWaitingConfirmCode="info.useWaitingConfirmCode" class="otp-wrap" />
      </header>
      <!-- 대기팀 & 예상 대기시간 -->
      <article class="middle">
        <waitingTeams :list="list" class="waiting-wrap" />
      </article>
      <!-- 호출 목록 -->
      <article class="bottom">
        <div v-if="notificationList[0]" class="title">해당 번호의 고객께선 <span class="entrance">지금 입장해주세요!</span></div>
        <div v-else class="title">입장 순서가 되면 아래에 대기번호가 나타납니다.</div>
        <entranceList :is-waiting-number="isWaitingNumber" :enter-item="enterItem" :list="list" :notification-list="notificationList" class="entrance-list-wrap"/>
      </article>
    </section>
    <aside class="right-container">
      <!-- 광고 & 호출 팝업 -->
      <adVideo :ad-list="adList" :ad-index="adIndex" class='ad-wrap' />
      <entrancePopup v-if="isPlaying" :is-waiting-number="isWaitingNumber" :class="{bounce: isPlaying}" :enter-item="enterItem" class="entrance-popup-wrap" />
    </aside>
    <div class="clock-wrap">
      <tb-clock /> | v {{version}}
    </div>
  </main>
</template>

<script>
import { textEllipsis } from '@/components/text'
import otp from './otp'
import waitingTeams from './waitingTeams'
import entranceList from './entranceList'
import adVideo from './adVideo'
import entrancePopup from './entrancePopup'
import tbClock from '@/components/tbClock'

export default {
  props: [
    'notification-list',
    'is-playing',
    'restaurant-idx',
    'enter-item',
    'ad-index',
    'ad-list',
    'info',
    'list',
    'msg',
    'menu-list',
    'display-menu',
    'expectation-time',
    'version',
    'otpNumber'
  ],
  name: 'horizontal-view',
  data () {
    return {
      resturantIdx: -1
    }
  },
  created () {
    try {
      const idx = parseInt(localStorage.getItem('restaurantIdx'))
      if (idx) {
        this.resturantIdx = idx
      }
    } catch (e) {
      console.error(e)
    }
  },
  computed: {
    isWaitingNumber () {
      // 특정 매장 대기번호 미출력 처리
      // https://mealantcloud.atlassian.net/browse/TB-9970
      if (process.env.VUE_APP_ENV === 'development') {
        switch (this.resturantIdx) {
          case 51725: // 포케(FE)
            return false
        }
      } else if (process.env.VUE_APP_ENV === 'staging') {
        switch (this.resturantIdx) {
          case 51677: // [QA] 7_전체 서비스+대기 주문 상태
            return false
        }
      } else if (process.env.VUE_APP_ENV === 'production') {
        switch (this.resturantIdx) {
          case 8899: // 로마경양식
            return false
        }
      }
      return true
    }
  },
  components: {
    tbClock, otp, waitingTeams, entranceList, adVideo, entrancePopup, textEllipsis
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/style.scss";

.horizontal-container {
  display:flex;
  width:100%;
  height:100vh;

  background-color: $gray_900;
  color: $white;
  font-family: Pretendard;
  padding: 24px;

  @include fhd_combo {
    padding: 36px;
  }
  @include qhd_combo {
    padding: 48px;
  }

  .left-container {
    max-width: calc(100% - 504px - 24px);
    flex: 1;
    flex-basis: 704px;
    display: flex;
    flex-flow: column nowrap;

    @include fhd_combo {
      max-width: calc(100% - 756px - 36px);
      flex-basis: 1056px;
    }

    @include qhd_combo {
      max-width: calc(100% - 1008px - 48px);
      flex-basis: 1408px;
    }

    .top {
      display: flex;
      align-items: center;
      flex-flow: column nowrap;
      flex-basis: 113px;
      padding: 5px 11px 5px;
      margin: 0 0 16px;

      @include fhd_combo {
        flex-basis: 170px;
        padding: 8px 16px 8px;
        margin: 0 0 24px;
      }

      @include qhd_combo {
        flex-basis: 227px;
        padding: 11px 21px 11px;
        margin: 0 0 32px;
      }

      & > .title {
        width: 100%;
        margin: 0;
        font-size: 27px;
        font-weight: $medium;
        letter-spacing: 0px;
        text-align: center;

        @include fhd_combo {
          font-size: 40px;
        }

        @include qhd_combo {
          font-size: 53px;
        }
      }

      .otp-wrap {
        height: 49px; // todo: 넘칠 때 확인 필요(필요 시 flex-basis로 변경)
        display: flex;
        align-items: center;
        background: $gray_800;
        border: 1px solid $gray_600;
        border-radius: 11px;
        padding: 8px 21px 9px;
        color: $gray_400;
        font-size: 21px;
        font-weight: $medium;
        margin: 16px 0 0;

        @include fhd_combo {
          height: 74px; // todo: 넘칠 때 확인 필요(필요 시 flex-basis로 변경)
          border: 2px solid $gray_600;
          border-radius: 16px;
          padding: 12px 32px 14px;
          font-size: 32px;
          margin: 24px 0 0;
        }

        @include qhd_combo {
          height: 99px;
          font-size: 42px;
          border: 3px solid $gray_600;
          border-radius: 21px;
          padding: 13px 40px 16px;
          margin: 32px 0 0;
        }
      }
    }

    .middle {
      flex-basis: 152px;

      @include fhd_combo {
        flex-basis: 228px;
      }

      .waiting-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column nowrap;
        border-radius: 16px;
        background: $gray_800;

        @include fhd_combo {
          border-radius: 24px;
        }
      }
    }

    .bottom {
      flex: 1;
      display: flex;
      flex-flow: column nowrap;
      background-color: $gray_800;
      margin: 16px 0 0 0;
      border-radius: 16px;

      @include fhd_combo {
        margin: 24px 0 0 0;
        border-radius: 24px;
      }
      @include qhd_combo {
        margin: 32px 0 0 0;
        border-radius: 32px;
      }

      & > .title {
        padding: 24px 0 21px;
        font-size: 33px;
        font-weight: $medium;
        color: $gray_400;

        @include fhd_combo {
          padding: 36px 0 32px;
          font-size: 50px;
        }

        @include qhd_combo {
          padding: 48px 0 43px;
          font-size: 66px;
        }
      }

      .entrance {
        color: $white;
      }

      .entrance-list-wrap {
        height: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-content: space-between;
        padding: 0 16px 16px;
        margin: 0;

        @include fhd_combo {
          padding: 0 24px 24px;
          margin: 0;
        }
        @include qhd_combo {
          padding: 0 32px 32px;
          margin: 0;
        }
      }
    }
  }

  .right-container {
    position: relative;
    flex-basis: 504px;
    margin-left: 24px;

    @include fhd_combo {
      flex-basis: 756px;
      margin-left: 36px;
    }

    @include qhd_combo {
      flex-basis: 1008px;
      margin-left: 48px;
    }

    .ad-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // border-radius: 16px;
      position: relative;
      overflow: hidden;
      background: $gray_800;

      @include fhd_combo {
        border-radius: 24px;
      }
    }

    .entrance-popup-wrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 448px;
      height: 616px;
      display: flex;
      align-items: center;
      background: url('../../assets/callTicket.svg') 100% 100% no-repeat;
      background-size: cover;
      background-position: center;
      flex-flow: column wrap;
      filter: drop-shadow(0px 5px 16px #13151755);

      @include fhd_combo {
        width: 672px;
        height: 924px;
        filter: drop-shadow(0px 8px 24px #13151755);
      }

      @include qhd_combo {
        width: 896px;
        height: 1232px;
        filter: drop-shadow(0px 11px 32px #13151755);
      }
    }
  }

  .clock-wrap {
    position: absolute;
    bottom: 5px;
    right: 24px;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;

    @include fhd_combo {
      bottom: 9px;
      right: 40px;
      font-size: 16px;
      line-height: 19px;
    }

    @include qhd_combo {
      bottom: 12px;
      right: 48px;
      font-size: 21px;
      line-height: 26px;
    }

    .time-text {
      display: inline-block;
    }
  }
}

.bounce {
  animation: bounce 7.5s ease-in-out;
}

@keyframes bounce {
  0% { top: 51%; }
  5% { top: 49%; }
  10% { top: 51%; }
  15% { top: 49%; }
  20% { top: 51%; }
  25% { top: 49%; }
  30% { top: 51%; }
  35% { top: 49%; }
  40% { top: 51%; }
  45% { top: 49%; }
  50% { top: 51%; }
  55% { top: 49%; }
  60% { top: 51%; }
  65% { top: 49%; }
  70% { top: 51%; }
  75% { top: 49%; }
  80% { top: 51%; }
  85% { top: 50%; }
}
</style>
